/* Isolated checkout: this product form only; no mutation of the Online Store bag. */
(() => {
  const query = `mutation TrauemyBuyNow($input: CartInput!, $language: LanguageCode!) @inContext(language: $language) {
    cartCreate(input: $input) {
      cart { checkoutUrl totalQuantity lines(first: 10) { nodes { quantity merchandise { ... on ProductVariant { id } } } } }
      userErrors { message } warnings { message }
    }
  }`;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-tm-buy-now]');
    if (!button || button.disabled) return;
    const form = button.closest('form'), owner = button.closest('product-form');
    const add = form.querySelector('[name=add]');
    if (add?.disabled || add?.getAttribute('aria-disabled') === 'true' || !form.reportValidity()) return;
    const data = new FormData(form), id = data.get('id'), quantity = Number(data.get('quantity') || 1);
    if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) return;
    const line = {merchandiseId: `gid://shopify/ProductVariant/${id}`, quantity};
    const attributes = [];
    for (const [key, value] of data) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string' && value) attributes.push({key: match[1], value});
    }
    if (attributes.length) line.attributes = attributes;
    if (data.get('selling_plan')) line.sellingPlanId = `gid://shopify/SellingPlan/${data.get('selling_plan')}`;
    button.disabled = true; button.setAttribute('aria-busy', 'true'); owner?.handleErrorMessage?.();
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch('/api/2026-07/graphql.json', {
        method: 'POST', signal: controller.signal, headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({query, variables: {language: ({'zh-Hans':'ZH_CN','zh-Hant':'ZH_TW'}[button.dataset.locale] || (button.dataset.locale || 'en').replace('-', '_').toUpperCase()), input: {lines: [line], buyerIdentity: {countryCode: button.dataset.country}}}})
      });
      const result = await response.json(), payload = result.data?.cartCreate, cart = payload?.cart;
      if (!response.ok || result.errors?.length || payload?.userErrors?.length || payload?.warnings?.length || !cart?.checkoutUrl)
        throw new Error(payload?.userErrors?.[0]?.message || payload?.warnings?.[0]?.message || button.dataset.error);
      if (cart.totalQuantity !== quantity || cart.lines.nodes.length !== 1 || cart.lines.nodes[0].merchandise.id !== line.merchandiseId)
        throw new Error(button.dataset.error);
      const checkout = new URL(cart.checkoutUrl);
      if (button.dataset.locale) checkout.searchParams.set('locale', button.dataset.locale);
      window.location.assign(checkout.href);
    } catch (error) {
      owner?.handleErrorMessage?.(error.name === 'AbortError' ? button.dataset.error : error.message || button.dataset.error);
      button.disabled = false; button.removeAttribute('aria-busy');
    } finally { clearTimeout(timer); }
  });
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-tm-buy-now][aria-busy]').forEach(button => {
    button.disabled = !!button.closest('form')?.querySelector('[name=add]')?.disabled;
    button.removeAttribute('aria-busy');
  }));
})();
